import React from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { Empty } from '@yandex-360/orb-components/dist/components/Empty';

import { TELEMOST_DESKTOP_URL_WEB } from '../../../../helpers/constants';
import { i18n } from '../../../../helpers/i18n';
import I18N from '../../../i18n';
import Link from '../../../link';
import { PngImage } from '../../../png-image';
import styles from './styles.css';

export const UnsupportedBrowserPageNew: React.FC = () => {
    return (
        <Empty
            content={<PngImage name="webStubDownload" className={styles.image} />}
            title={<span className={styles.title}>{i18n('error-page', 'usupported-browser-title-v2')}</span>}
            description={
                <I18N keyset="error-page" loc="unsupported-browser-subtitle-v3" className={styles.description}>
                    <Link
                        className={styles.yabroLink}
                        data-ref="link-yabro"
                        view="default"
                        href="https://browser.yandex.ru"
                        target="_blank"
                    />
                </I18N>
            }
            button={
                <Button elementType="a" href={TELEMOST_DESKTOP_URL_WEB} target="_blank" view="brand">
                    {i18n('error-page', 'download-yandex-telemost')}
                </Button>
            }
            className={styles.unsupportedBrowser}
        />
    );
};
